export default [
    {
        value: "Comunicacao",
        text: "Comunicação"
    },
    {
        value: "CusteioCursoPosGraduacao",
        text: "Custeio de curso de pós-graduação"
    },
    {
        value: "Encadernacao",
        text: "Encadernação"
    },
    {
        value: "Frete",
        text: "Frete"
    },
    {
        value: "Impressao",
        text: "Impressão"
    },
    {
        value: "LocacaoDeEquipamento",
        text: "Locacao de equipamento"
    },
    {
        value: "RateioDeAdministracaoGeral",
        text: "Rateio de administração geral"
    },
    {
        value: "ServicoDeRegistroDePatente",
        text: "Serviço de registro de patente"
    },
    {
        value: "TaxaDeInscricaoEmEvento",
        text: "Taxa de inscrição em evento"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]